import PropTypes from "prop-types";
import { Button, Checkbox, Select, SettingsCard, Space } from "top-component-library";
import { FormRow, SettingHint } from "../styles";

// Mirrors editCustomerProperties.html's "Restaurant Chain Config" card - despite the name,
// this sets this account to share billing/branding with another account, and has nothing to
// do with Customer.chain_parent/chain_children.
const CopyPropertiesCard = ({ customerName, allowedCustomers, config, importing, onChange, onImport }) => {
  const nothingToImport =
    !config.source_customer ||
    !(config.copy_billpayer || config.copy_stripe_account || config.copy_icons || config.link_employees);

  return (
    <SettingsCard title="Restaurant Chain Config">
      <SettingHint>
        You can set this account to use the same bill payer or Stripe account as another account.
      </SettingHint>
      <FormRow>
        <label htmlFor="customer-properties-chain-source">Import from</label>
        <Select
          id="customer-properties-chain-source"
          value={config.source_customer?.customer_id}
          onChange={(customerId) =>
            onChange("source_customer", allowedCustomers.find((option) => option.customer_id === customerId) ?? null)
          }
        >
          {allowedCustomers.map((option) => (
            <Select.Option key={option.customer_id} value={option.customer_id}>
              {option.name_for_admin}
            </Select.Option>
          ))}
        </Select>
        <label>into {customerName}</label>
      </FormRow>
      <Space direction="vertical">
        <Checkbox
          checked={config.copy_billpayer}
          onChange={(event) => onChange("copy_billpayer", event.target.checked)}
        >
          Use same Billpayer (for our SaaS fees)
        </Checkbox>
        <Checkbox
          checked={config.copy_stripe_account}
          onChange={(event) => onChange("copy_stripe_account", event.target.checked)}
        >
          Connect same Stripe account
        </Checkbox>
        <Checkbox checked={config.copy_icons} onChange={(event) => onChange("copy_icons", event.target.checked)}>
          Same menuitem icons
        </Checkbox>
        <Checkbox
          checked={config.link_employees}
          onChange={(event) => onChange("link_employees", event.target.checked)}
        >
          Same employees
        </Checkbox>
        <Button type="primary" loading={importing} disabled={nothingToImport} onClick={onImport}>
          Import from selected
        </Button>
      </Space>
    </SettingsCard>
  );
};

CopyPropertiesCard.propTypes = {
  customerName: PropTypes.string.isRequired,
  allowedCustomers: PropTypes.arrayOf(
    PropTypes.shape({ customer_id: PropTypes.string.isRequired, name_for_admin: PropTypes.string.isRequired })
  ).isRequired,
  config: PropTypes.shape({
    source_customer: PropTypes.shape({
      customer_id: PropTypes.string.isRequired,
      name_for_admin: PropTypes.string.isRequired,
    }),
    copy_billpayer: PropTypes.bool.isRequired,
    copy_stripe_account: PropTypes.bool.isRequired,
    copy_icons: PropTypes.bool.isRequired,
    link_employees: PropTypes.bool.isRequired,
  }).isRequired,
  importing: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onImport: PropTypes.func.isRequired,
};

export default CopyPropertiesCard;
